import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { Card } from '@/components/primitives/Card';
import { Button } from '@/components/primitives/Button';
import { Spinner } from '@/components/primitives/Spinner';
import { Icon } from '@/components/Icon';
import { useOgAuth } from '@/api/opengater/OgAuthContext';
import { OpengaterLogin } from './OpengaterLogin';
import s from './Opengater.module.css';
import { PageTitle } from '@/components/PageTitle';
/**
 * Layout + auth gate for every `/opengater/*` route.
 *
 * Provides the section's auth context, then gates:
 *   - not logged in            → the OG login card
 *   - logged in, but not staff → "access denied" (a plain `user` logged in)
 *   - logged in as staff       → the actual section (<Outlet/>)
 *
 * This sits INSIDE the panel shell (sidebar/topbar stay visible), so the
 * Opengater login is a second, section-scoped gate on top of the panel's own
 * auth — the "separate Opengater login" the section was speced with.
 */
function OgAccessDenied() {
    const { email, logout } = useOgAuth();
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: "Opengater Manager", sub: "\u0414\u043E\u0441\u0442\u0443\u043F \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D" }), _jsx(Card, { children: _jsxs("div", { className: s.wip, children: [_jsx(Icon, { name: "lock", size: 26, className: s.wipIcon }), _jsx("div", { className: s.wipTitle, children: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043F\u0440\u0430\u0432" }), _jsxs("div", { className: s.wipSub, children: ["\u0423 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430", email ? ` ${email}` : '', " \u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043D\u0438 \u043A \u043E\u0434\u043D\u043E\u043C\u0443 \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u043F\u0430\u043D\u0435\u043B\u0438. \u0412\u043E\u0439\u0434\u0438\u0442\u0435 \u043F\u043E\u0434 \u0440\u0430\u0431\u043E\u0447\u0438\u043C \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443."] }), _jsx(Button, { variant: "ghost", onClick: () => void logout(), style: { marginTop: 6 }, children: "\u0412\u044B\u0439\u0442\u0438 \u0438 \u0441\u043C\u0435\u043D\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442" })] }) })] }));
}
function OgGate() {
    const { isAuthed, isStaff, roleStatus } = useOgAuth();
    if (!isAuthed)
        return _jsx(OpengaterLogin, {});
    if (roleStatus === 'loading') {
        return (_jsx(Card, { children: _jsxs("div", { className: s.wip, children: [_jsx(Spinner, { size: 18 }), _jsx("div", { className: s.wipSub, children: "\u041F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u043C \u043F\u0440\u0430\u0432\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430\u2026" })] }) }));
    }
    if (!isStaff)
        return _jsx(OgAccessDenied, {});
    return _jsx(Outlet, {});
}
export function OpengaterLayout() {
    return _jsx(OgGate, {});
}
